import { ActionIcon, ThemeIcon, Tooltip } from '@mantine/core';
import { IconCalendarPause, IconCheck, IconX, IconQuestionMark } from '@tabler/icons-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './status-cell.module.css';

import { FORM_STATUS } from '@data-access';

export const STYLES = {
  [FORM_STATUS.FINISHED]: {
    icon: IconCheck,
    color: 'pf-green',
  },
  [FORM_STATUS.INCOMPLETE]: {
    icon: IconX,
    color: 'red',
  },
  [FORM_STATUS.PENDING]: {
    icon: IconCalendarPause,
    color: 'yellow.6',
  },
  [FORM_STATUS.REJECTED]: {
    icon: IconX,
    color: 'red',
  },
  [FORM_STATUS.ERROR]: {
    icon: IconX,
    color: 'gray.6',
  },
  [FORM_STATUS.UNDEFINED]: {
    icon: IconQuestionMark,
    color: 'orange.6',
  },
};

export interface StatusCellProps {
  status: FORM_STATUS;
  onClick?: () => void;
}

export const StatusCell = forwardRef<any, StatusCellProps>((props, ref) => {
  const style = STYLES[props.status];
  if (!style) {
    return null;
  }

  const Icon = style.icon;
  const color = style.color;

  // Determine the tooltip label based on the status

  return (
    <ActionIcon
      aria-label="Settings"
      className={classes.button}
      color={color}
      component={props.onClick ? 'button' : 'div'}
      disabled={!props.onClick}
      onClick={props.onClick}
      radius="md"
      ref={ref}
      size="md"
      variant="filled"
    >
      <Icon stroke={3.5} style={{ width: '80%', height: '80%' }} />
    </ActionIcon>
  );
});

export default StatusCell;
